import { createMutation } from '@tanstack/svelte-query';
import { createScene, deleteScene, updateScene } from '$lib/api/scene';
import { invalidateAfterSceneCreate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { SceneRequest, SceneResponse } from '$lib/types/scene';

export const createSceneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<SceneResponse, Error, SceneRequest>(() => ({
		mutationFn: (request) => createScene(request),
		onSuccess: () => invalidateAfterSceneCreate(resolveScope(scope))
	}));

export const updateSceneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<SceneResponse, Error, { id: number; request: Partial<SceneRequest> }>(() => ({
		mutationFn: ({ id, request }) => updateScene(id, request),
		onSuccess: () => invalidateAfterSceneCreate(resolveScope(scope))
	}));

export const deleteSceneMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteScene(id),
		onSuccess: () => invalidateAfterSceneCreate(resolveScope(scope))
	}));
